var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"locale-changer column",class:{'mobile': _vm.$isMobile}},[(_vm.$i18n.locale === 'tr')?_c('a',{attrs:{"href":_vm.url}},[_vm._v("EN")]):_c('a',{attrs:{"href":_vm.url}},[_vm._v("TR")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e8505d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/widget/header/language.vue
// module id = 629
// module chunks = 34